import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ChevronRight } from 'lucide-react';
import { useLang } from '../../context/LanguageContext';
import { GEO_LABELS } from '../../data/geo';
import { SITE_URL } from '../../data/site';

// Visible breadcrumb + BreadcrumbList JSON-LD.
// items: [{ label, to }]  (last item = current page, no link)
const Breadcrumbs = ({ items = [] }) => {
  const { lang } = useLang();
  const home = { label: GEO_LABELS[lang].home, to: '/' };
  const all = [home, ...items];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: all.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.label,
      item: `${SITE_URL}${it.to === '/' ? '' : it.to}`,
    })),
  };

  return (
    <nav aria-label="Breadcrumb" className="text-[12.5px]">
      <Helmet><script type="application/ld+json">{JSON.stringify(jsonLd)}</script></Helmet>
      <ol className="flex flex-wrap items-center gap-1.5 text-slate-400">
        {all.map((it, i) => {
          const last = i === all.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5">
              {last ? (
                <span className="font-semibold text-slate-600" aria-current="page">{it.label}</span>
              ) : (
                <Link to={it.to} className="hover:text-blue-700 transition-colors">{it.label}</Link>
              )}
              {!last && <ChevronRight className="w-3.5 h-3.5" aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
